<template>
<section class="saic-act_container">
    <div class="header">
        <img src="../assets/images/mb/mbanner@2x.png"/>
    </div>
    <section class="form-saic">
       <div class="container">
            <div class="warn">
                <h1>申请补贴注意事项</h1>
                <p>1.上汽荣威官方授权经销商及二级经销商处购买的车辆才能享受以旧换新的补贴，其他非官方授权店购买的荣威车辆无法享受相关补贴；
                <p>2.“以旧换新”活动时间为5月1日至6月30日，开具发票的时间需要在此时间段内，并在开具发票后2个月内完成申请并通过系统审核；</p>
                <p>3.活动车型有ERX5、Ei5 300KM、eRX5、e950、RX8、RX5、RX3、i6、i5，其他车型不参与此次活动；</p>
                <p>4.上传资料后审核结果于30天内短信通知，审核不通过可联系当地经销商了解原因；</p>
                <p>5. 联系人信息与购车人信息一致；</p>
                <p>6.本次活动最终解释权归上汽荣威官方所有。</p>
            </div>
            <FormMb  />
        </div>
    </section>
</section>
</template>

<script>
import FormMb from './FormMb.vue'

export default {
  name: 'layout',
  props: {
    msg: String
  },
  components: {
    FormMb
  },
  data () {
    return {
        devicePhone: false
    }
  },
  mounted () {
  }
}
</script>

<style scoped lang="scss">

.header {
    img {
        width: 100%;
    }
}

.container {
    width: 100%;
    margin: 0 auto;
    min-height: 100px;
    box-sizing: border-box;
    padding:px2rem(80px) px2rem(20px) px2rem(2px);
    background: #fff;
}

.form-saic {
    margin: px2rem(30px);
}

.warn {
    color: #333333;
    margin-bottom: px2rem(70px);
    h1{
        font-size: px2rem(36px);
        font-weight: bold;
        text-align: center;
        line-height: px2rem(36px);
        margin-bottom: px2rem(38px);
    }
    p{
        color: #666;
        font-size: px2rem(24px);
        line-height: px2rem(48px);
    }
}
</style>